import {getterSetter, getFormObject, isEmpty, isSet, isValidEmail, isValidName, source,isMobile, isNumberOrSpecialKeyPressed} from '../../utils/common';
import {requirementService} from '../../services/requirementService';
import {otpService} from '../../services/otpService';
import {getCookie} from '../../services/cookieService'
import {addEvent} from '../../utils/gaService';
import countries from '../../nri/country_code';
import constants from '../../cityConstant.js';
import {login} from '../../loginService';
import {Component} from '../../core';

// The initial state of this component
const initialState = {
    cities: [
        ...constants.data.topCities,
        ...constants.data.allCities
    ],
    cityIds: [],
    cityNavIdx: -1,
    elCityNavLast: null,
    countryNavIdx: -1,
    elCountryNavLast: null,
    isOtpSent: false,
    isOtpEntered: false,
    isLeadEnrichForStaticForm: false,
    enrichmentFormPayload: {
        requirementId: '',
        businessType: '',
        employeeStrength: '',
        requirementFrequency: '',
        rentDuration: '',
        budget: '',
        noOfOfficeLocations: '',
        requiredWithIn: '',
        additionalInfo: ''
    }
};

// Analytics events for this page
const analytics = {
    GA: {
        packagedSelectedSubmitClicked: (type) => {
            let pageType = 'SnBpage'
            if(globals.pageType == 'CoworkVAP') {
                pageType = 'VAP';
            } 
            if(globals.pageType == 'CoworkHome') {
                pageType = 'Homepage';
            }
            if(type != '') {
                addEvent('QH_CoWork', pageType+'_CoWork_Center-tile', 'QH_CoWork_'+pageType+'_Center-tile_featured-spaces_Click');    
            } else {
                addEvent('QH_CoWork', pageType+'_CoWork_Center-tile', 'QH_CoWork_'+pageType+'_Center-tile_Book-Tour_submit_Click');
            }
        }
    }
};

/**
 * Cowork contact component
 */
export class CoworkDynamicContactComponent extends Component {

    static alias = 'cowork-dynamic-contact';

    constructor(el, state) {
        CoworkDynamicContactComponent.alias = 'cowork-dynamic-contact'+state.propertyId;
        super(el, {...initialState, ...state});
    }

    onComponentLoaded() {
        // Initialize the scope bindings
        this.showForm();
        this.handleCountrySearch = this.handleCountrySearch.bind(this);
        this.handleCountrySuggestionNavigation = this.handleCountrySuggestionNavigation.bind(this);
        this.handleCountrySelection = this.handleCountrySelection.bind(this);
        this.handleOtpGeneration = this.handleOtpGeneration.bind(this);
        this.showOtpField = this.showOtpField.bind(this);
        this.handleOtpInput = this.handleOtpInput.bind(this);
        this.handleInputValidationOnChange = this.handleInputValidationOnChange.bind(this);
        this.handleFormSubmission = this.handleFormSubmission.bind(this);
        this.handleFormAfterLoginSubmission = this.handleFormAfterLoginSubmission.bind(this);
        this.clearFormErrors();
        this.clearFormMessages();
        this.clearFormValues();
        
        //Hide tahnkyou..
        this.checkLogin();
        // Initialize the contact form
        this.initializeContactForm();
        //console.log(this.state.propertyId);
        this.getProeprtyDetailPayload(this.state.propertyDetail);
    }

    checkLogin() {
        if(getterSetter.get('loginstatus')) {
            let details = getterSetter.get('loginData');
            this.setLoggedInData(details.data.user);
            this.refs.sendOtp.classList.add('hide');
            this.refs.otpSection.classList.add('hide');
            this.refs.phone.readOnly = true;
            this.refs.email.readOnly = true;
            this.refs.name.value = getterSetter.get('name');
            this.refs.phone.value = getterSetter.get('mobile');
            this.refs.email.value = getterSetter.get('email');
            this.refs.submit.disabled = false;
            this.state.isOtpSent = true;
            this.state.isOtpEntered = true;
        }
    }

    /**
     * Initializes the contact form
     */
    initializeContactForm() {
        // Initialize form animations
        this.initializeFormAnimations();

        // Initialize form lead enrichment form
        this.initializeLeadenrichmentForm();

        // Initialize the country suggest
        this.initializeCountrySuggest();

        // Initialize OTP actions
        this.initializeOtpActions();

        // Initialize the form validations
        this.initializeFormValidation();

        // Initialize form submission
        this.initializeFormSubmission();
    }

    /**
     * Initializes all form animations
     */
    initializeFormAnimations() {
        // Initialize the floating labels
        [...this.refs.form.querySelectorAll('[animated]')]
            .forEach((elInput) => {
                elInput.addEventListener('blur', () => {
                    if (elInput.value.trim()) {
                        elInput.parentElement.classList.add('f_open');
                    } else {
                        elInput.parentElement.classList.remove('f_open');
                    }
                });
            });
    }

    initializeLeadenrichmentForm() {
        [...this.refs.enrichmentForm.querySelectorAll('[enrichoption]')]
            .forEach((elInput) => {
                elInput.addEventListener('click', ({target: {dataset: {value, field}, innerHTML: txtVal}}) => {
                    this.refs[field].innerHTML = txtVal;
                    this.state.enrichmentFormPayload[field] = value;

                    if (!elInput.parentElement.classList.contains('slected')) {
                        elInput.parentElement.classList.add('slected');
                    }
                });
            });

            this.refs.additionalInfo.addEventListener('keyup', ({target: {value: textVal}}) => {
                this.state.enrichmentFormPayload.additionalInfo = textVal;
                if (textVal.length < 1000) {
                    this.refs.enrichLeadError.innerHTML = '';
                    if (!this.refs.enrichLeadError.classList.contains('hide')) {
                        this.refs.enrichLeadError.classList.add('hide');
                    }
                } else {
                    this.refs.enrichLeadError.innerHTML = 'Max 1000 Characters';
                    this.refs.enrichLeadError.classList.remove('hide');
                }
            });
            this.refs.additionalInfo.addEventListener('paste', ({target: {value: textVal}}) => {
                if (textVal.length > 1000) {
                    this.refs.additionalInfo.value = textVal.substring(0, 1000);
                    this.state.enrichmentFormPayload.additionalInfo = textVal.substring(0, 1000);
                }
            });
    }

    /**
     * Initializes all OTP actions
     */
    initializeOtpActions() {
        this.refs.phone.onkeydown = isNumberOrSpecialKeyPressed;
        this.refs.otp.onkeydown = isNumberOrSpecialKeyPressed;
        this.refs.otp.addEventListener('input', this.handleOtpInput);
        this.refs.resendOtp.addEventListener('click', this.handleOtpGeneration);
        this.refs.phone.addEventListener('input', () => {
            if (this.state.isOtpSent) {
                this.state.isOtpSent = false;
                this.state.isOtpEntered = false;

                // Clear and hide the OTP section
                this.clearAndHideOtpField();

                // CLear errors and messages
                this.clearFormErrors(['phone']);
                this.clearFormMessages(['phone']);
            }
        });
    }

    setLoggedInData(data) {
        data.userMobile = (typeof data.userMobile === 'undefined') ? [] : data.userMobile;
        data.userEmail = (typeof data.userEmail === 'undefined') ? [] : data.userEmail;
        data.userEmail.length > 0 ? getterSetter.set('email',data.userEmail[0].emailId) : getterSetter.set('email','');
        data.userMobile.length > 0 ? getterSetter.set('mobile',data.userMobile[0].mobileNumber) : getterSetter.set('mobile','');
        (data.firstName && data.firstName != '') ? getterSetter.set('name',data.firstName) : getterSetter.set('name','');
        getterSetter.set('loggedInUserId',data.id);
    }

    /**
     * Initializes the form validation
     */
    initializeFormValidation() {
        [...this.refs.form.querySelectorAll('[validator]')]
            .forEach((elInput) => {
                elInput.addEventListener('blur', this.handleInputValidationOnChange);
                elInput.addEventListener('keyup', this.handleInputValidationOnChange);
            });
    }

    submitclick (ev) {
        // Generate OTP if not verified
        if(getterSetter.get('loginstatus')) {
            this.handleFormAfterLoginSubmission();
        } else {
            if (!this.state.isOtpSent && !this.state.isOtpEntered) {
                this.handleOtpGeneration();
            } else {
                this.handleFormSubmission();
            }
        }
    }

    /**
     * Event handler to handle Lead Enrichment submission
     */
    enrichSubmitClick() {
        // Validate 
        this.refs.enrichLeadError.innerHTML = '';
        if (!this.refs.enrichLeadError.classList.contains('hide')) {
            this.refs.enrichLeadError.classList.remove('hide');
        }
        if (this.state.enrichmentFormPayload.requirementId !== '') {
            
            this.submitEnrichmentLead(this.state.enrichmentFormPayload)
                .catch((err) => {
                    // Display an error
                    this.refs.enrichLeadError.innerHTML = 'Something went wrong!';
                    this.refs.enrichLeadError.classList.remove('hide');
                    throw err;
                })
                .then(() => {
                    this.showSuccess();
                    this.removeEnrichListener();
                })
                .catch(() => {});
        } else {
            this.refs.enrichLeadError.innerHTML = 'Something went wrong';
            this.refs.enrichLeadError.classList.remove('hide');
        }
    }

    /**
     * Remove enrich submit listener
     */
    removeEnrichListener() {
        this.refs.enrichSubmit.removeEventListener('click', this.enrichSubmitClick);
    }

    /**
     * Initializes the form submission
     */
    initializeFormSubmission() {
        let that = this;
        this.refs.submit.addEventListener('click', this.submitclick.bind(that));
        this.refs.enrichSubmit.addEventListener('click', this.enrichSubmitClick.bind(that));

        this.refs.sendOtp.addEventListener('click', function otpsend (ev) {
            // Prevent the browser from submitting
            //ev.preventDefault();

            // Generate OTP if not verified
            if(getterSetter.get('loginstatus')) {
                that.handleFormAfterLoginSubmission();
            } else {
                if (!that.state.isOtpSent && !that.state.isOtpEntered) {
                    that.handleOtpGeneration();
                } else {
                    that.handleFormSubmission();
                }
            }
        });
    }

    /**
     * Initializes the phone codes dropdown
     */
    initializeCountrySuggest() {
        // Render all the countries initially
        this.renderCountrySuggestions(countries);

        // Attach the event handlers for country suggestions
        this.refs.countrySearch.addEventListener('input', this.handleCountrySearch);
        this.refs.countrySearch.addEventListener('keydown', this.handleCountrySuggestionNavigation);
        this.refs.countrySuggestions.addEventListener('click', this.handleCountrySelection);
    }

    /**
     * Event handler to handle country search
     * 
     * @param {KeyboardEvent} param0 the `input` event
     */
    handleCountrySearch({target: {value}}) {
        // Normalize the string prior to usage
        value = value.trim().toLowerCase();

        // Filter by matching the phone codes or the name itself
        const matchingCountries = countries.filter((country) => 
            country.dial_code.includes(value) || country.name.toLowerCase().startsWith(value));

        // Render the matching countries
        this.renderCountrySuggestions(matchingCountries);
    }

    /**
     * Event handler to navigate the country suggestions dropdown
     * 
     * @param {KeyboardEvent} ev the `keydown` event
     */
    handleCountrySuggestionNavigation(ev) {
        const elSuggestions = this.refs.countrySuggestions.children;
        const totalSuggestions = this.refs.countrySuggestions.childElementCount;

        if (this.state.elCountryNavLast) {
            this.state.elCountryNavLast.classList.remove('active');
        }

        // Update the cursor
        if (40 === ev.keyCode && this.state.countryNavIdx < (totalSuggestions - 1)) {
            this.state.countryNavIdx += 1;
            this.state.elCountryNavLast = elSuggestions.item(this.state.countryNavIdx);
            this.state.elCountryNavLast.classList.add('active');

            // Scroll down
            if (this.state.elCountryNavLast.offsetTop + this.state.elCountryNavLast.scrollHeight > this.refs.countrySuggestions.clientHeight) {
                this.refs.countrySuggestions.scrollTop = this.refs.countrySuggestions.scrollTop + this.state.elCountryNavLast.scrollHeight;
            }
        } else if (38 === ev.keyCode && this.state.countryNavIdx > 0) {
            this.state.countryNavIdx -= 1;
            this.state.elCountryNavLast = elSuggestions.item(this.state.countryNavIdx);
            this.state.elCountryNavLast.classList.add('active');

            // Scroll Up
            if (this.state.elCountryNavLast.offsetTop + this.state.elCountryNavLast.scrollHeight > this.refs.countrySuggestions.clientHeight) {
                this.refs.countrySuggestions.scrollTop = this.refs.countrySuggestions.scrollTop - this.state.elCountryNavLast.scrollHeight;
            }
        } else if (13 === ev.keyCode) {
            ev.preventDefault();
            elSuggestions.item(this.state.countryNavIdx).click();
        }
    }

    /**
     * Event handler to handle country selection from suggestions
     * 
     * @param {MouseEvent} param0 the `click` event
     */
    handleCountrySelection({target: {dataset: {value, country}}}) {
        if (!value || !country) return;

        // Store the selected 
        this.refs.hiddenPhoneCode.value = value;
        this.refs.hiddenCountryCode.value = country;
        this.refs.labelPhoneCode.textContent = value;

        // Hide the OTP field and reset the OTP state
        this.clearAndHideOtpField();
    }

    /**
     * Event handler to handle OTP generation and re-generation
     */
    handleOtpGeneration() {
        // Validate the form
        const formData = getFormObject(this.refs.form);
        const validationErrors = this.getValidationErrors(formData);

        // Ensure the form is valid
        if (validationErrors) {
            this.showFormErrors(validationErrors);
            return;
        }

        // Clear the form errors
        this.clearFormErrors();

        // Set the requirement details in store
        this.setRequirementDetailsInStore(formData);

        // Initiate OTP generation if not sent
        this.generateOtp()
            .then(this.showOtpField)
            .catch(() => {
                // Display an error
                this.showFormErrors({
                    phone: 'OTP not sent, please try again'
                });
            });
    }

    /**
     * Event handler to handle OTP fill in
     */
    handleOtpInput() {
        // Clear any existing errors and messages
        this.showFormErrors({ phone: '' });
        this.showFormMessages({ phone: '' });

        this.state.isOtpEntered = (4 === this.refs.otp.value.length)

        // Enable the "Get Started" button once the OTP is entered
        this.refs.submit.disabled = !this.state.isOtpEntered;
    }

    /**
     * Event handler to handle form validation on focus out
     * 
     * @param {FocusEvent} ev the `blur` event
     */
    handleInputValidationOnChange({target}) {
        const formData = getFormObject(this.refs.form);
        const validatorName = target.getAttribute('validator');
        const validationErrors = this.getValidationErrors(formData, [validatorName]);

        if (null === validationErrors) {
            this.clearFormErrors([validatorName]);
        }
    }

    /**
     * Event handler to handle OTP submission
     */
    handleFormSubmission() {
        // Validate 
        const formData = getFormObject(this.refs.form);
        const validationErrors = this.getValidationErrors(formData);

        if (!validationErrors && this.state.isOtpEntered) {
            // Set the requirement details in store
            this.setRequirementDetailsInStore(formData);
            if(isSet(this.state.typeval)) {
                analytics.GA.packagedSelectedSubmitClicked('featured');
            } else {
                analytics.GA.packagedSelectedSubmitClicked(''); 
            }
            this.validateOtpAndLogin(formData)
                .catch((err) => {
                    // Display an error
                    this.showFormErrors({
                        phoneotp: 'OTP entered is invalid'
                    });

                    throw err;
                })
                .then(() => {
                    this.showSuccess();
                    return this.addRequirement();
                })
                .then((response) => {
                    if (response.data != '') {
                        this.state.enrichmentFormPayload.requirementId = response.data;
                    }

                    if (200 == response.statusCode) {
                        this.refs.reqId.value = response.data;
                    }
                })
                .catch(() => {});
        }
    }

    handleFormAfterLoginSubmission() {
        const formData = getFormObject(this.refs.form);
        const validationErrors = this.getValidationErrors(formData);
        if (validationErrors) {
            this.showFormErrors(validationErrors);
            return;
        } else {
            this.setRequirementDetailsInStore(formData);
            if(isSet(this.state.typeval)) {
                analytics.GA.packagedSelectedSubmitClicked('featured');
            } else {
                analytics.GA.packagedSelectedSubmitClicked(''); 
            }
            this.showSuccess();
            return this.addRequirement();
        }
    }

    showEnrichmentForm() {
        document.getElementById('co_workEnquiryPopup').classList.add('leadenrichmentform');
        document.getElementById('co_workEnquiryPopup').classList.remove('co_workEnquiryPopup');
        this.refs.dynamicForm.classList.add('hide');
        this.refs.enrichmentForm.classList.remove('hide');
    }

    showSuccess() {
        const isEnriched = localStorage.getItem('isEnriched');

        if (isEnriched) {
            const modalClass = document.getElementById('co_workEnquiryPopup').classList;
            if (modalClass.contains('leadenrichmentform')) {
                document.getElementById('co_workEnquiryPopup').classList.remove('leadenrichmentform');
            }
            if (!modalClass.contains('co_workEnquiryPopup')) {
                document.getElementById('co_workEnquiryPopup').classList.add('co_workEnquiryPopup');
            }

            if (this.refs.dynamicForm) {
                this.refs.dynamicForm.classList.add('hide');
            }
            this.refs.enrichmentForm.classList.add('hide');
            this.refs.thankuPopup.classList.remove('hide');
            this.refs.submit.removeEventListener('click', this.submitclick);
        } else {
            this.showEnrichmentForm();
        }
    }

    showForm() {
        if (document.getElementById('co_workEnquiryPopup') && !this.state.isLeadEnrichForStaticForm) {
            const modalClass = document.getElementById('co_workEnquiryPopup').classList;
            if (modalClass.contains('leadenrichmentform')) {
                document.getElementById('co_workEnquiryPopup').classList.remove('leadenrichmentform');
            }
            if (!modalClass.contains('co_workEnquiryPopup')) {
                document.getElementById('co_workEnquiryPopup').classList.add('co_workEnquiryPopup');
            }
        }

        if (document.getElementById('co_workEnquiryPopup') && this.state.isLeadEnrichForStaticForm) {
            const modalClass = document.getElementById('co_workEnquiryPopup').classList;
            if (!modalClass.contains('leadenrichmentform')) {
                document.getElementById('co_workEnquiryPopup').classList.add('leadenrichmentform');
            }
            if (modalClass.contains('co_workEnquiryPopup')) {
                document.getElementById('co_workEnquiryPopup').classList.remove('co_workEnquiryPopup');
            }
        }

        if (this.refs.thankuPopup && !this.refs.thankuPopup.classList.contains('hide')) {
            this.refs.thankuPopup.classList.add('hide');
        }

        if (this.refs.enrichmentForm && !this.refs.enrichmentForm.classList.contains('hide') && !this.state.isLeadEnrichForStaticForm) {
            this.refs.enrichmentForm.classList.add('hide');
        }

        if (this.refs.enrichmentForm && this.refs.enrichmentForm.classList.contains('hide') && this.state.isLeadEnrichForStaticForm) {
            this.refs.enrichmentForm.classList.remove('hide');
        }

        if (this.refs.dynamicForm && !this.state.isLeadEnrichForStaticForm) {
            this.refs.dynamicForm.classList.remove('hide');
        }
    }

    /**
     * Validate the form data and returns the validity
     * 
     * @param {Object} formData Cowork requirement form data
     */
    getValidationErrors(formData, validators = []) {
        const isNRIPhone = 'IN' !== formData.countryCode;
        const validity = {
            name: {
                isValid: isSet(formData.name) && formData.name.length >= 3 && formData.name.length <= 32 && isValidName(formData.name),
                message: 'Please enter a valid name'
            },
            email: {
                isValid: isValidEmail(formData.email),
                message: 'Please enter a valid email'
            },
            phone: {
                isValid: isSet(formData.phoneCode) && !isEmpty(formData.phoneCode) &&
                    isSet(formData.phone) && !isEmpty(formData.phone) && (isNRIPhone ? /^[0-9]{4,15}$/.test(formData.phone) : /^[6789]\d{9}$/.test(formData.phone)),
                message: 'Enter a valid mobile number'
            }
        };

        return Object.keys(validity)
            .filter((v) => 0 === validators.length || validators.includes(v))
            .every((v) => validity[v].isValid || ('isValidPattern' in validity[v] && (validity[v].isValidPattern))) ? null : Object.keys(validity)
                .filter((v) => 0 === validators.length || validators.includes(v))
                .reduce((errors, field) => {
                    if (!validity[field].isValid) {
                        errors[field] = validity[field];
                    }
                    return errors;
                }, {});
    }

    /**
     * Sets the requirement details in the store
     */
    setRequirementDetailsInStore(requirement) {
        getterSetter.set('name', requirement.name);
        getterSetter.set('email', requirement.email);
        getterSetter.set('phonecode', requirement.phoneCode.replace('+', ''));
        getterSetter.set('isNRIMobile', '+91' !== requirement.phoneCode);
        getterSetter.set('mobile', requirement.phone);
        getterSetter.set('otpFlag', false);
    }

    /**
     * Renders countries in the countries suggest
     * 
     * @param {Array} countries the countries list
     */
    renderCountrySuggestions(countries = []) {
        this.refs.countrySuggestions.innerHTML = countries.reduce((html, country) => html + `
            <li tabindex="-1" data-value="${country.dial_code}" data-country="${country.code}">${country.dial_code} (${country.name})</li>
        `, '');
    }

    /**
     * Hides the OTP generation button and unhides the OTP field
     */
    showOtpField() {
        this.refs.otpSection.classList.remove('hide');
        this.refs.otp.setAttribute('tabindex', '0');
        this.refs.otp.disabled = false;
        this.refs.otp.parentElement.classList.remove('disabled');
        this.refs.sendOtp.classList.add('hide');
        this.refs.resendOtp.classList.remove('hide');
    }

    /**
     * Hides the OTP field and unhides the "Send OTP" button
     */
    clearAndHideOtpField() {
        // Clear the OTP
        this.refs.otp.value = '';

        // Hide the OTP field and unhide the "Send OTP" button
        this.refs.submit.type = 'button';
        this.refs.sendOtp.classList.remove('hide');
        this.refs.otp.parentElement.classList.remove('show');
    }

    /**
     * Shows the form messages
     * 
     * @param {Object} messages for form fields
     */
    showFormMessages(messages = {}) {
        // Clear the messages prior to displaying any
        this.clearFormMessages();

        if (messages) {
            // Populate the messages
            Object.keys(messages)
                .map((fieldName) => this.refs.form.querySelector(`.message[for=${fieldName}]`))
                .forEach((elMsg) => (elMsg.textContent = messages[elMsg.getAttribute('for')]));
        }
    }

    /**
     * Clears all the form messages, not errors
     */
    clearFormMessages(fields = []) {
        if (fields && fields.length > 0) {
            // Populate the messages
            fields.map((fieldName) => this.refs.form.querySelector(`.message[for=${fieldName}]`))
                .forEach((elMsg) => (elMsg.textContent = ''));
        } else {
            // Clear all the messages
            this.refs.form.querySelectorAll('.message[for]')
                .forEach((elMsg) => (elMsg.textContent = ''));
        }
    }

    /**
     * Shows the form validation errors 
     * 
     * @param {Object} errors form validation errors
     */
    showFormErrors(errors = {}) {
        // Clear the errors prior to displaying them
        this.clearFormErrors();

        if (errors) {
            // Populate the errors
            Object.keys(errors)
                .map((fieldName) => this.refs.form.querySelector(`.error[for=${fieldName}]`))
                .forEach((elError) => (elError.textContent = (errors[elError.getAttribute('for')].message || errors[elError.getAttribute('for')])));
        }
    }

    /**
     * Clears all the form errors
     */
    clearFormErrors(fields = []) {
        if (fields && fields.length > 0) {
            // Populate the errors
            fields.map((fieldName) => this.refs.form.querySelector(`.error[for=${fieldName}]`))
                .forEach((elError) => (elError.textContent = ''));
        } else {
            // Clear all the errors
            if (this.refs.form) {
                this.refs.form.querySelectorAll('.error[for]')
                    .forEach((elError) => (elError.textContent = ''));
            }
        }
    }

    clearFormValues() {
        this.refs.name.value = '';
        this.refs.phone.value = '';
        this.refs.email.value = '';
        this.clearAndHideOtpField();
        this.refs.otp.disabled = true;
        this.refs.otp.parentElement.parentElement.classList.add('disabled');
    }

    
    /**
     * Generates OTP, returns a `Promise`
     */
    generateOtp() {
        if (this.state.isOtpSent) {
            // Build the OTP generation payload
            const payload = {
                otpId: otpService.getOtpVariable().otpId,
                otpClientId: otpService.getOtpVariable().otpClientId,
                source: source(),
                page: 'REPLY'
            };

            // Trigger resend OTP
            return otpService.resendOTP(payload)
                .then((response) => {
                    // Clear the OTP field
                    this.refs.otp.value = '';
                    this.state.isOtpEntered = false;

                    if (!('response' in response)) {
                        throw response;
                    }

                    return JSON.parse(response.response).ResendOTPApplicationResponse;
                })
                .then((data) => {
                    // TODO: Show a message that the OTP has been resent
                    this.state.isOtpSent = true;
                    otpService.setOtpVariable(data.ResendOTPApplication.otpId, 'otpId');

                    this.showFormMessages({
                        phone: `OTP sent on ${getterSetter.get('mobile')}`
                    });


                    return data;
                });
        }

        // Build the OTP generation payload
        const payload = {
            email: getterSetter.get('email'),
            mobile: getterSetter.get('mobile'),
            firstName: getterSetter.get('name'),
            source: source(),
            page: 'REPLY'
        };

        // Prepend the phone code to the mobile number
        if (getterSetter.get('isNRIMobile')) {
            payload.mobile = getterSetter.get('phonecode').replace('+', '') + payload.mobile;
        }

        return otpService.generateOTP(payload)
            .then((response) => {
                if (!('response' in response)) {
                    this.state.isOtpSent = false;
                    throw response;
                }
    
                otpService.setOtpVariable(response.clientId, 'otpClientId');
                return JSON.parse(response.response).GenerateOTPApplicationResponse;
            })
            .then((data) => {
                this.state.isOtpSent = true;
                this.state.isOtpEntered = false;
                otpService.setOtpVariable(data.GenerateOTPApplication.otpId, 'otpId');

                this.showFormMessages({
                    phone: `OTP sent on ${getterSetter.get('mobile')}`
                });

                return data;
            });
    }

    validateOtpAndLogin(formData) {
        const payload = {
            GreetingName: formData.phone,
            password: '',
            otpRequest: 1,
            otpNumber : formData.otp,
            otpId: otpService.getOtpVariable().otpId,
            page: 'REPLY',
            source: source()
        };

        return login(payload).then((response) => {
            if (response.error) {
                throw response.data;
            }

            if (response.status == 'AUTH_SUCCESS') {
                if(response && response.data && response.data.user) {
                    getterSetter.set('loginData', response);
                    getterSetter.set('loginstatus', true);
                    getterSetter.set('otpFlag', true);
                    getterSetter.set('userId', response.data.user.id);
                } else {
                    getterSetter.set('otpFlag', false);
                    getterSetter.set( 'loginstatus', false);
                }

                if ('undefined' !== typeof PUB_SUB) {
                    PUB_SUB.emit('do_login', {name: formData.name});
                }     
            }
        });
    }

    submitEnrichmentLead() {
        let formData = this.state.enrichmentFormPayload;
        Object.keys(formData).forEach((key) => {
            if (formData[key] === '') {
                delete formData[key];
            }
        });
        return requirementService.saveLeadEnrichment(formData).then((res) => {
            if (res.data) {
                localStorage.setItem('isEnriched', true);
                return res;
            }

            if (res.error) {
                throw res.error;
            }
        }).catch((err) => {
            throw err;
        });
    }

    addRequirement() {
        return requirementService.addCoworkRequirement(this.coworkDefaultPayLoad());
    }

    coworkDefaultPayLoad() {
        let cityName = this.refs.cityNameInit.value;
        let cityId = this.refs.cityIdInit.value;
        let propertyId = this.state.propertyId;
        let source = 'HOMEPAGE';
        if(globals.pageType == 'CoworkSNB') {
            source = 'COWORK_SNB';
        } else if(globals.pageType == 'CoworkHome') {
            source = 'HOMEPAGE';
        } else if(globals.pageType == 'CoworkVAP') {
            source = 'COWORK_VAP';
        } 
        let channel = isMobile() ? 'MOBILE': 'DESKTOP';


        let propertydetail = this.getProeprtyDetailPayload(this.state.propertyDetail);
        let amenitiesList = [];
        if(propertydetail && propertydetail.amenities && propertydetail.amenities.length>0) {
            propertydetail.amenities.reduce((amenity) => {
                if(amenity && amenity.amenities && amenity.amenities.length>0) {
                    amenity.amenities.map((item, i) => {
                        amenitiesList.push(item);
                    });  
                }  
            });
        }

        //id optional
        return {
                "source": source,
                "propertyId":(propertyId) ? propertyId : 1000,
                "userId": getCookie('__u') || '',
                "userName":  getterSetter.get('name')|| '',
                "userEmail": getterSetter.get('email'),
                "userMobile": getterSetter.get('mobile'),
                "channel": channel,
                "referer":location.hostname,
                "cityName": propertydetail.cityName || '',
                "cityId": propertydetail.cityId || '',
                "localityName":propertydetail.localityName || '',
                "localityId" : propertydetail.localityId || '',
                "unitTypeList": propertydetail.unitType || '',
                "amenitiesList":amenitiesList || '',
            }
    }

    getProeprtyDetailPayload(propertyDetail) {
        let decodeval = atob(propertyDetail);
        if(decodeval != '') {
            let parseVal = JSON.parse(decodeval);
            return parseVal;
        }
    }

}
